import React from 'react';
import { Typography, AutoComplete } from 'antd';
import { FormInput, FormTextArea } from '../../ui/inputs/form-input';
import { CustomTooltip } from './custom-tooltip';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import type { BaseFieldProps } from '../../../types/form-renderer';
import type { InputField as InputFieldType } from '../../../types/templates';

const { Text } = Typography;

type Props = BaseFieldProps<InputFieldType> & { onBlur?: () => void };

export const InputField: React.FC<Props> = ({ field, value, onChange, onBlur, commonStyle, labelStyle, error }) => {
  const { fontSize } = useResponsiveSizes();
  const isMultiline = field.multiline;
  const suggestions = !isMultiline && field.options && field.options.length > 0 ? field.options : undefined;

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>
      <CustomTooltip field={field}>
        {isMultiline ? (
          <FormTextArea
            size='S'
            placeholder={field.placeholder}
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            status={error ? 'error' : undefined}
            autoSize={{ minRows: 3, maxRows: 8 }}
          />
        ) : suggestions ? (
          <AutoComplete
            placeholder={field.placeholder}
            style={{ width: '100%', fontSize: commonStyle.fontSize }}
            value={value || ''}
            onChange={onChange}
            onBlur={onBlur}
            status={error ? 'error' : undefined}
            options={suggestions.map(o => ({ value: o.value, label: o.label ?? o.value }))}
            filterOption={(input, option) =>
              String(option?.value ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        ) : (
          <FormInput
            size='S'
            placeholder={field.placeholder}
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            status={error ? 'error' : undefined}
          />
        )}
      </CustomTooltip>
      {error && (
        <Text type='danger' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
